module.exports = __webpack_public_path__ + "media/images/how-location-96912192f1b2c0d71c1ade3bf24787ef.png";